const routes = {
  HOMEPAGE: '/',
  ACCOUNT: '/account',
  REGISTER: '/register',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CATALOG: '/katalog',
  GAME: '/play/',
};

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js